import { AppointmentStatus } from "../models/AppointmentModels";
import "./AppointmentStatusBadge.css";

export const appointmentStatusLabel: Record<number, string> = {
  [AppointmentStatus.Scheduled]: "Scheduled",
  [AppointmentStatus.CheckedIn]: "Checked in",
  [AppointmentStatus.InProgress]: "In progress",
  [AppointmentStatus.Completed]: "Completed",
  [AppointmentStatus.Cancelled]: "Cancelled",
  [AppointmentStatus.NoShow]: "No show",
  [AppointmentStatus.WalkIn]: "Walk-in",
  [AppointmentStatus.ScheduledByPublicWeb]: "Website booking",
};

const appointmentStatusClass: Record<number, string> = {
  [AppointmentStatus.Scheduled]: "scheduled",
  [AppointmentStatus.CheckedIn]: "checkedin",
  [AppointmentStatus.InProgress]: "inprogress",
  [AppointmentStatus.Completed]: "completed",
  [AppointmentStatus.Cancelled]: "cancelled",
  [AppointmentStatus.NoShow]: "noshow",
  [AppointmentStatus.WalkIn]: "walkin",
  [AppointmentStatus.ScheduledByPublicWeb]: "web",
};

interface AppointmentStatusBadgeProps {
  status: AppointmentStatus;
}

const AppointmentStatusBadge = ({ status }: AppointmentStatusBadgeProps) => (
  <span
    className={`appt-status-badge appt-status-badge--${appointmentStatusClass[status] ?? "unknown"}`}
  >
    {appointmentStatusLabel[status] ?? "Unknown"}
  </span>
);

export default AppointmentStatusBadge;
